/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuRepresentativeOffice() {
  const intl = useIntl()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Quản lý văn phòng</span>
        </div>
      </div>
      <AsideMenuItem
        to='/sales'
        icon='/media/svg/custom/icn_revenue.svg'
        title='Doanh số'
        fontIcon='bi-layers'
      />
      {/* <AsideMenuItem
        to='/partners'
        icon='/media/svg/custom//icn_partner.svg'
        title='Đối tác'
        fontIcon='bi-layers'
      /> */}
      <AsideMenuItemWithSub
        to='/manage-client'
        title='Quản lý khách hàng'
        icon='/media/svg/custom/icn_partner.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/manage-client/report-new-client' title='Báo cáo số lượng KH mới' hasBullet={true} />
        {/* <AsideMenuItem to='/manage-client/client-category' title='Danh mục khách hàng' hasBullet={true} /> */}
      </AsideMenuItemWithSub>
      <AsideMenuItem
        to='/installment-package'
        icon='/media/svg/custom//icn_poll.svg'
        title='Gói trả góp'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/income'
        icon='/media/svg/custom/icn_location.svg'
        title='Thu nhập'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}
